<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const props = defineProps<{
    message: string
    type: string
}>()

const { t, te } = useI18n()

// Translate a backend/i18n key if it exists, else fall back to the raw string.
function tr(key: string): string {
    if (!key) return ''
    return te(key) ? t(key) : key
}
</script>

<template>
    <div
        class="div-message-error-option-happy"
        :class="props.type"
        v-if="props && props.type === 'error'"
    >
        <svg
            class="svg-error-option-happy"
            viewBox="0 0 800 800"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M458.417 70.3748C433.087 24.3229 366.917 24.3231 341.587 70.3748L31.2965 634.54C6.85981 678.97 39.004 733.333 89.711 733.333H710.293C761 733.333 793.143 678.97 768.707 634.54L458.417 70.3748Z"
                fill="#EF2929"
            />
            <path
                d="M433 287.333C433 268.924 418.073 254 399.667 254C381.257 254 366.333 268.924 366.333 287.333V453.999C366.333 472.409 381.257 487.332 399.667 487.332C418.073 487.332 433 472.409 433 453.999V287.333Z"
                fill="white"
            />
            <path
                d="M399.667 620.666C422.677 620.666 441.333 602.012 441.333 578.999C441.333 555.989 422.677 537.332 399.667 537.332C376.653 537.332 358 555.989 358 578.999C358 602.012 376.653 620.666 399.667 620.666Z"
                fill="white"
            />
        </svg>

        <p class="whitespace-break-spaces">
            {{ tr(props.message) }}
        </p>

        <svg
            class="svg-error-option-happy"
            viewBox="0 0 800 800"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M458.417 70.3748C433.087 24.3229 366.917 24.3231 341.587 70.3748L31.2965 634.54C6.85981 678.97 39.004 733.333 89.711 733.333H710.293C761 733.333 793.143 678.97 768.707 634.54L458.417 70.3748Z"
                fill="#EF2929"
            />
            <path
                d="M433 287.333C433 268.924 418.073 254 399.667 254C381.257 254 366.333 268.924 366.333 287.333V453.999C366.333 472.409 381.257 487.332 399.667 487.332C418.073 487.332 433 472.409 433 453.999V287.333Z"
                fill="white"
            />
            <path
                d="M399.667 620.666C422.677 620.666 441.333 602.012 441.333 578.999C441.333 555.989 422.677 537.332 399.667 537.332C376.653 537.332 358 555.989 358 578.999C358 602.012 376.653 620.666 399.667 620.666Z"
                fill="white"
            />
        </svg>
    </div>

    <div
        class="text-center font-semibold pb-2 flex justify-center gap-1"
        :class="props.type"
        v-if="props && props.type === 'warning'"
    >
        <p>
            {{ tr(props.message) }}
        </p>
    </div>
</template>

<style scoped>
.div-message-error-option-happy {
    @apply text-center font-semibold pb-2 flex justify-between gap-1 px-2;
}

.svg-error-option-happy {
    @apply w-5 h-5 min-w-5 min-h-5;
}

.error {
    @apply text-red-eronor;
}

.warning {
    @apply text-button-yellow-happy-light;
}
</style>
